import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    user: null
}


const authSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        loginUser(state, action) {
            console.log("login user", action.payload)
            state.user = action.payload
            console.log("STATE.USER", state.user)
            const { accessToken } = action.payload
            state.token = accessToken
            if(state.user !== undefined) {
                localStorage.setItem("user", JSON.stringify(state.user))
                localStorage.setItem("userId", JSON.stringify(state.user._id))
            }
            if(state.token !== undefined) {
                localStorage.setItem("token", JSON.stringify(state.token))
            }
            
        },
        logoutUser(state, action) {
            state.user = null
            state.token = null
            localStorage.removeItem("user", JSON.stringify(state.user))
            localStorage.removeItem("reloaded")
            localStorage.removeItem("favoriteItems")
            localStorage.removeItem("userId")
        },
        updateCurrentUser(state, action) {
            state.user = action.payload
            console.log("state.user", state.user);
            localStorage.setItem("user", JSON.stringify(state.user))
        },
    },
})


export const { loginUser, logoutUser, updateCurrentUser } = authSlice.actions;

export default authSlice.reducer